// extracted by mini-css-extract-plugin
export default {"PricingFAQ__footer":"styles-module__PricingFAQ__footer___vAN48","hide-md":"styles-module__hide-md___qj3aZ"};